<template>
    <div :class="$style.complete">
        <img src="@/assets/images/guide-complete.png" />
        <h2>{{ $t('guide.guide_complete_title') }}</h2>
        <p>
            {{ $t('guide.guide_complete_desc') }}
        </p>
        <pt-button color="lightblue" @click="handleClick">
            {{ $t('guide.guide_complete_close_btn') }}
        </pt-button>
        <span>{{ $t('guide.guide_complete_close_tip') }}</span>
    </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import { useConfetti } from '@hooks/useConfetti';
import useLocalData from '@hooks/useLocalData';

const emit = defineEmits(['close', 'trackEvent']);

const { getLocalData, updateLocalData } = useLocalData();

onMounted(() => {
    if (!getLocalData('startGuideConfetti').visible) {
        useConfetti({
            angle: 150,
            particleCount: 200,
            spread: 70,
            origin: { x: 1.1, y: 0.7 },
            startVelocity: 50,
            scalar: 1,
            zIndex: 2147483647
        });
        updateLocalData('startGuideConfetti', {
            visible: true
        });
    }
});

function handleClick() {
    emit('close');
    emit('trackEvent', 'guide_complete_close');
}
</script>

<style lang="scss" module>
@import '@style/import.scss';

.complete {
    text-align: center;
    padding: 20px 40px 58px;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
        width: 120px;
    }

    h2 {
        font-weight: 400;
        font-size: 20px;
        text-align: center;
        color: $pt-black-900;
        margin: 40px 0 8px;
    }

    p {
        font-size: 14px;
        line-height: 20px;
        color: $pt-black-900;
    }

    button {
        margin: 64px auto 16px;
    }

    > span {
        font-weight: 400;
        font-size: 12px;
        line-height: 17px;
        color: $pt-black-600;
    }
}
</style>
